<script setup>
import { OnClickOutside } from '@vueuse/components';

const userStore = useUserStore();
const modalStore = useModalStore();

const show = ref(false);
const showDonationModal = ref(false);
const donationAmounts = [
  { amount: 1000, src: 'ceek-token-1k.webp' },
  { amount: 100, src: 'ceek-token-100.webp' },
  { amount: 10, src: 'ceek-token-10.webp' },
  { amount: 1, src: 'ceek-token-1.webp' },
];

const ceekToPay = ref(0);

defineProps({
  artists: {
    type: Array,
    required: true,
    default: () => [{}],
  },
  meetingCreator: {
    type: Object,
    default: null,
  },
  horizontalDropDawn: {
    type: Boolean,
    default: false,
  },
});

async function showModal(item) {
  if (!userStore.IS_AUTHORIZED) {
    await modalStore.SHOW_MODAL({
      component: 'MoleculeModalNeedAuth',
    });

    return;
  }

  ceekToPay.value = item.amount;
  showDonationModal.value = true;
  show.value = false;
}
</script>

<template>
  <div>
    <OnClickOutside class="relative flex items-center justify-center" @trigger="show = false">
      <div
        class="absolute flex gap-1"
        :class="[!horizontalDropDawn ? 'flex-col bottom-[115%]' : 'flex-row -left-[150px]']"
      >
        <ClientOnly>
          <template v-if="show">
            <button
              v-for="item in donationAmounts"
              :key="item.amount"
              type="button"
              class="donation size-8 z-40"
              @click.prevent="showModal(item)"
            >
              <AtomImage :src="`/images/payments/${item.src}`" class="size-full" />
            </button>
          </template>
        </ClientOnly>
      </div>
      <button type="button" class="size-8" @click.prevent="show = !show">
        <slot name="donation-icon">
          <MoleculeNuxtIcon name="donation-coin" :filled="true" class="size-8" />
        </slot>
      </button>
    </OnClickOutside>
    <MoleculeModalDonation
      v-if="showDonationModal"
      :artists="artists"
      :meeting-creator="meetingCreator"
      :ceek="ceekToPay"
      @close="showDonationModal = false"
      @click.prevent
    />
  </div>
</template>
